import { Modal, Col } from "antd";
import { Flex, Box } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "components/Button/PrimaryButton";
import { useForm } from "react-hook-form";
import Field from "components/Input/Field/index";
import InputMoney from "components/Input/InputMoney/index";
import { PrevisaoOrcamentariaLancamento } from "core/features/previsao-orcamentaria/typings/index";
import { showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { OperacaoEnum } from "resources/enums/conta";
import { FormaDistribuicaoLancamento } from "features/previsao-orcamentaria/typings";
import useAtualizarLancamentoMes from "core/features/previsao-orcamentaria/hooks/useAtualizarLancamentoMes";
import { PlanejamentoOrcamentarioDetalheItemResponse } from "core/features/previsao-orcamentaria/typings";
import { useLoading } from "components/GlobalLoading/index";

interface ModalEditarMesLancamentoProps {
  onClose: () => void;
  visible: boolean;
  previsaoId?: string;
  data: PlanejamentoOrcamentarioDetalheItemResponse | undefined;
  refetch: any;
  mes: string | undefined;
}

const getMesNome = (mes: string) => {
  if (mes === "01") {
    return "Janeiro";
  }
  if (mes === "02") {
    return "Fevereiro";
  }
  if (mes === "03") {
    return "Março";
  }
  if (mes === "04") {
    return "Abril";
  }
  if (mes === "05") {
    return "Maio";
  }
  if (mes === "06") {
    return "Junho";
  }
  if (mes === "07") {
    return "Julho";
  }
  if (mes === "08") {
    return "Agosto";
  }
  if (mes === "09") {
    return "Setembro";
  }
  if (mes === "10") {
    return "Outubro";
  }
  if (mes === "11") {
    return "Novembro";
  }
  return "Fevereiro";
};

const defaultValuesForm: Partial<PrevisaoOrcamentariaLancamento> = {
  valor: undefined,
  categoriaFinanceiraId: undefined,
  formaDistribuicao: FormaDistribuicaoLancamento.IgualTodosMeses,
  operacao: OperacaoEnum.Despesa,
  mesInicio: undefined,
  mesFim: undefined,
};

export default function ModalEditarMesLancamento({
  onClose,
  visible,
  previsaoId,
  refetch,
  data,
  mes,
}: ModalEditarMesLancamentoProps) {
  const { mutate: atualizarLancamento, isLoading: isAttLoading } =
    useAtualizarLancamentoMes({
      id: previsaoId,
      mes,
    });
  const { control, handleSubmit, reset } = useForm<{ valor: number }>({});

  const onSubmit = async (form: PrevisaoOrcamentariaLancamento) => {
    atualizarLancamento(
      { ...form, categoriaFinanceiraId: data?.id },
      {
        onSuccess: () => {
          onClose();
          showSuccess().then(refetch);
        },
      }
    );
  };

  useEffect(() => {
    if (data) {
      reset({
        valor: data.previsto,
      });
    }
  }, [data, reset]);

  useEffect(() => {
    if (!visible) {
      reset(defaultValuesForm);
    }
  }, [reset, visible]);

  useLoading(isAttLoading);

  return (
    <Modal
      centered
      destroyOnClose
      width="500px"
      visible={visible}
      onCancel={onClose}
      title={`Editar lançamento de ${getMesNome(String(mes))}`}
      footer={
        <Flex flex={1} justify="end" gap={4}>
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
          <PrimaryButton onClick={() => handleSubmit(onSubmit)()}>
            Salvar
          </PrimaryButton>
        </Flex>
      }
    >
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Box as={Col} sm={24} mb={4}>
          <Field
            label="Valor previsto"
            control={control}
            name="valor"
            rules={{
              required: "Campo obrigatório",
            }}
            render={({ field, isInvalid }) => (
              <InputMoney
                isInvalid={isInvalid}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        </Box>
      </form>
    </Modal>
  );
}
